import { createFileRoute } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import { CancellationPolicies } from '@mews-commander/modules/src/modules/enterprisePolicies';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/EnterprisePolicies/CancellationPolicies/Index/'
)({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('admin');
        checkPrivilege('configureEnterprise');
    },
    component: CancellationPolicies,
    staticData: {
        routeName: RouteName.EnterpriseCancellationPoliciesIndex,
        title: TextKey.CancellationPolicyPlural,
        owner: MewsTeam.Pricing,
        type: RouteType.Frontend,
    },
});
